import CaseNotes from './CaseNotes';

export default CaseNotes;
